var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.668 5.35157H5.33464C4.62739 5.35157 3.94911 5.63298 3.44902 6.13389C2.94892 6.6348 2.66797 7.31418 2.66797 8.02257V26.7195C2.66797 27.4279 2.94892 28.1073 3.44902 28.6082C3.94911 29.1091 4.62739 29.3905 5.33464 29.3905H24.0013C24.7085 29.3905 25.3868 29.1091 25.8869 28.6082C26.387 28.1073 26.668 27.4279 26.668 26.7195V17.3711M24.668 3.34833C25.1984 2.81703 25.9178 2.51855 26.668 2.51855C27.4181 2.51855 28.1375 2.81703 28.668 3.34833C29.1984 3.87962 29.4964 4.60021 29.4964 5.35157C29.4964 6.10294 29.1984 6.82353 28.668 7.35482L16.0013 20.0421L10.668 21.3775L12.0013 16.0356L24.668 3.34833Z",
    stroke: "currentColor",
    strokeWidth: 2.78261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLarge);
export default __webpack_public_path__ + "static/media/edit-large.2861201720501daf88da74bdd9865791.svg";
export { ForwardRef as ReactComponent };